import { createFileRoute } from "@tanstack/react-router";
import { ProcurementCalendarOverviewPage } from "@/pages/procurement-calendar-overview";
import { preloadProcurementCalendarOverviewQueries } from "@/pages/procurement-calendar-overview/api/preload-queries";
import { searchParams } from "@/pages/procurement-calendar-overview/model/search-params";

export const Route = createFileRoute("/_authed/$companySlug/horizon/")({
  component: ProcurementCalendarOverviewPage,
  loader: ({ context }) => {
    if (context.company) {
      void preloadProcurementCalendarOverviewQueries(context.company.id);
    }
  },
  validateSearch: searchParams,
});
